import { Component } from '@angular/core';

@Component({
  selector: 'app-client-marquee',
  templateUrl: './client-marquee.component.html',
  styleUrls: ['./client-marquee.component.scss']
})
export class ClientMarqueeComponent {

  client_logos:any = [];
  
  constructor() {
    this.client_logos = [
      {
        url: 'assets/img/logos/3-Aashirwad Hospital.png',
        alt: 'Aashirwad Hospitals logo'
      }, {
        url: 'assets/img/logos/6-SMS Hospital.png',
        alt: 'SMS Hospital logo'
      }, {
        url: 'assets/img/logos/17-New Balaji.png',
        alt: 'New Balaji logo'
      }, {
        url: 'assets/img/logos/prakash_hospital.png',
        alt: 'Prakash Hospital logo'
      }, {
        url: 'assets/img/logos/Infinity.png',
        alt: 'Infinity Care Hospital logo'
      }, {
        url: 'assets/img/logos/East Delhi Medical Centre copy.webp',
        alt: 'East Delhi Medical Centre logo'
      }, {
        url: 'assets/img/logos/md_city.png',
        alt: 'MD City Hospital logo'
      }, {
        url: 'assets/img/logos/Neelkanth_.png',
        alt: 'Neelkanth Hospitals Pvt. Ltd. logo'
      }, {
        url: 'assets/img/logos/Numed.png',
        alt: 'Numed Super Speciality Hospital logo'
      }, {
        url: 'assets/img/logos/Phoenix.png',
        alt: 'Phoenix Hospitals logo'
      }, {
        url: 'assets/img/logos/7-med-logo-final_350px_Registered copy.webp',
        alt: '7Med logo'
      }, {
        url: 'assets/img/logos/19-Kailash Hospital G.Z.B.png',
        alt: 'Kailash Hospital G.Z.B logo'
      }, {
        url: 'assets/img/logos/Vinayak Hospital logo.png',
        alt: 'Vinayak Hospital logo'
      }, {
        url: 'assets/img/logos/22-Kukreja Hospital.png',
        alt: 'Kukreja Hospital logo'
      }, {
        url: 'assets/img/logos/24-Makkar.png',
        alt: 'Makkar logo'
      }, {
        url: 'assets/img/logos/26-vardhman Healthcare.png',
        alt: 'vardhman Healthcare logo'
      }, {
        url: 'assets/img/logos/29-RS Grover Hospital.png',
        alt: 'RS Grover Hosptial logo'
      }, {
        url: 'assets/img/logos/31-Orchid IVF.png',
        alt: 'Orchid IVF logo'
      }, {
        url: 'assets/img/logos/11-C.M Patel Hospital.png',
        alt: 'C.M Patel Hospital logo'
      }, {
        url: 'assets/img/logos/13-J.P Memorial Hospital.png',
        alt: 'J.P Memorial Hospital logo'
      }, {
        url: 'assets/img/logos/14-Apex Citi.png',
        alt: 'Apex Citi logo'
      }, {
        url: 'assets/img/logos/16-SRH.png',
        alt: 'SRH logo'
      }, {
        url: 'assets/img/logos/PrimeIVF.png',
        alt: 'Prime IVF logo'
      }, {
        url: 'assets/img/logos/shiny medical centre.webp',
        alt: 'Shiny Medical Centre logo'
      }, {
        url: 'assets/img/logos/34-Maa Fertility Centre.png',
        alt: 'Maa Fertility Centre logo'
      }, {
        url: 'assets/img/logos/35-Blue Circle.png',
        alt: 'Blue Circle logo'
      }, {
        url: 'assets/img/logos/36-Poddar Nursing Home.png',
        alt: 'Poddar Nursing Home logo'
      }, {
        url: 'assets/img/logos/Aavaam Hospital logo.png',
        alt: 'Aavaam Hospital logo'
      }, {
        url: 'assets/img/logos/BH Salvas Logo.png',
        alt: 'BH Salvas logo'
      }, {
        url: 'assets/img/logos/Nishkarsh Hospital Logo.png',
        alt: 'Nishkarsh Hospital Logo'
      }, {
        url: 'assets/img/logos/38-Jain Hospital.png',
        alt: 'Jain Hosital logo'
      }, {
        url: 'assets/img/logos/40-Shankhawar Hospital.png',
        alt: 'Shankhawar Hospital logo'
      }, {
        url: 'assets/img/logos/42-Navjeevan Hospital.png',
        alt: 'Navjeevan Hospital logo'
      }, {
        url: 'assets/img/logos/44-SRS Meerut.png',
        alt: 'SRS Meerut logo'
      }, {
        url: 'assets/img/logos/48-Neelkanth Hospital La midas.png',
        alt: 'Neelkanth Hospital La midas logo'
      }, {
        url: 'assets/img/logos/49-JR Hospital.png',
        alt: 'JR Hospital logo'
      }, {
        url: 'assets/img/logos/50-Navin Hospitals.png',
        alt: 'Navin Hospitals.png logo'
      }, {
        url: 'assets/img/logos/51-khandelwal Hospital.png',
        alt: 'khandelwal Hospital logo'
      }, {
        url: 'assets/img/logos/52-Delhi ENT Hospital.png',
        alt: 'Delhi ENT Hospital logo'
      }, {
        url: 'assets/img/logos/53-Surya Kiran Hospital.png',
        alt: 'Surya Kiran Hospital.png logo'
      }, {
        url: 'assets/img/logos/54-Vikas Hospital.png',
        alt: 'Vikas Hospital logo'
      }, {
        url: 'assets/img/logos/56-Delhi Heart Hospitals.png',
        alt: 'Delhi Heart Hospitals logo'
      }, {
        url: 'assets/img/logos/58-IIMT University.png',
        alt: 'IIMT University logo'
      }, {
        url: 'assets/img/logos/59-Mangalyatan University.png',
        alt: 'Mangalyatan University logo'
      }, {
        url: 'assets/img/logos/60-Shivam.png',
        alt: 'Shivam Hospitals logo'
      }, {
        url: 'assets/img/logos/aakash hospital.webp',
        alt: 'Aakash Hospital logo'
      }, {
        url: 'assets/img/logos/Aakash Medsquare Logo copy.webp',
        alt: 'Aakash Medsquare logo'
      }, {
        url: 'assets/img/logos/amicare.webp',
        alt: 'Amicare logo'
      }, {
        url: 'assets/img/logos/Asclepius Hospital copy.webp',
        alt: 'Asclepius Hospital'
      }, {
        url: 'assets/img/logos/Bakson copy.webp',
        alt: 'Bakson logo'
      }, {
        url: 'assets/img/logos/Dharmlata Hospital copy.webp',
        alt: 'Dharmlata Hospital logo'

      },
      {
        url: 'assets/img/logos/Eves Hospital copy.webp',
        alt: 'Eves Hospital logo'
      }, {
        url: 'assets/img/logos/FEMINEST-LOGO-new1 copy.webp',
        alt: 'FEMINEST logo'
      }, {
        url: 'assets/img/logos/Garg Hospital copy.webp',
        alt: 'Garg Hospital logo'
      }, {
        url: 'assets/img/logos/Jyoti Nursing Home copy.webp',
        alt: 'Jyoti Nursing Home logo'
      }, {
        url: 'assets/img/logos/kapoor medical centre.webp',
        alt: 'Jyoti Nursing Home logo'
      }, {
        url: 'assets/img/logos/khetarpal-nursing-home-rajouri-garden-1-86992 copy.webp',
        alt: 'Khetarpal nursing home logo'
      }, {
        url: 'assets/img/logos/Life Care Centre copy.webp',
        alt: 'Life Care Centre logo'
      }, {
        url: 'assets/img/logos/Madhup Logo copy.webp',
        alt: 'Madhup logo'
      }, {
        url: 'assets/img/logos/Monga Hosptial copy.webp',
        alt: 'Monga Hosptial logo'
      }, {
        url: 'assets/img/logos/Nagar Hospital copy.webp',
        alt: 'Nagar Hospital logo'
      }, {
        url: 'assets/img/logos/New Medical Center Logo copy.webp',
        alt: 'New Medical Center logo'
      }, {
        url: 'assets/img/logos/Nimms Hospital Dadri copy.webp',
        alt: 'Nimms Hospital Dadri logo'
      }, {
        url: 'assets/img/logos/orthocare.webp',
        alt: 'orthocare logo'
      }, {
        url: 'assets/img/logos/panchsheel.webp',
        alt: 'panchsheel logo'
      }, {
        url: 'assets/img/logos/Raj Rani Hospital Logo copy.webp',
        alt: 'Raj Rani Hospital logo'
      }, {
        url: 'assets/img/logos/Tripathi Hospital copy.webp',
        alt: 'Tripathi Hospital logo'
      }, {
        url: 'assets/img/logos/V Care Hospital copy.webp',
        alt: 'V Care Hospital logo'

      },
      {
        url: 'assets/img/logos/tulsi hospital.png',
        alt: 'Tulsi Hospital logo'
      }, {
        url: 'assets/img/logos/nix hospital.png',
        alt: 'Nix Hospital logo'
      }, {
        url: 'assets/img/logos/dr sjh.png',
        alt: 'Dr SJH logo'
      }, {
        url: 'assets/img/logos/nova hospital.png',
        alt: 'Nova Hospital logo'
      }, {
        url: 'assets/img/logos/yashraj hospital.png',
        alt: 'Yashraj Hospital logo'
      }, {
        url: 'assets/img/logos/lenus oncology.png',
        alt: 'Lenus Oncology logo'
      }, {
        url: 'assets/img/logos/yashoda nursing home.png',
        alt: 'Yashoda Nursing Home logo'
      }, {
        url: 'assets/img/logos/vedanta.png',
        alt: 'Vedanta logo'
      }, {
        url: 'assets/img/logos/ferticore ivf.png',
        alt: 'Ferticore IVF logo'
      }, {
        url: 'assets/img/logos/baby bloom.png',
        alt: 'Baby Bloom logo'
      }, {
        url: 'assets/img/logos/rajinder hospital.png',
        alt: 'Rajinder Hospital logo'
      }, {
        url: 'assets/img/logos/md super.png',
        alt: 'MD Super logo'
      }, {
        url: 'assets/img/logos/remidius healthcare.png',
        alt: 'Remidius Healthcare logo'
      }, {
        url: 'assets/img/logos/central hospital.png',
        alt: 'Central Hospital logo'
      }, {
        url: 'assets/img/logos/sm hospital.png',
        alt: 'SM Hospital logo'
      }, {
        url: 'assets/img/logos/metro lyf hospital.png',
        alt: 'Metro Lyf Hospital logo'
      }, {
        url: 'assets/img/logos/doctors plaza.png',
        alt: 'Doctors Plaza logo'
      }, 
      {
        url: 'assets/img/logos/raj deep.png',
        alt: 'Raj Deep logo'
      }, {
        url: 'assets/img/logos/raj eye.png',
        alt: 'Raj Eye logo'
      }, 
      {
        url: 'assets/img/logos/chaudhary medicare.png',
        alt: 'Chaudhary Medicare logo'
      }, {
        url: 'assets/img/logos/deep medical.png',
        alt: 'Deep Medical logo'
      }, {
        url: 'assets/img/logos/mediworld.png',
        alt: 'Mediworld logo'
      }

    ]
  }
}
